import type { PayloadAction } from "@reduxjs/toolkit";
import { createSlice } from "@reduxjs/toolkit";
import { MemberSettings } from "@types";
import { buildMemberSettings, getStoredMemberSettings } from "@utils/member-settings";
import { BeforeInstallPromptEvent, InfoResponse } from "kz-ui-sdk";

export interface PreferenceSliceState {
  serverInfo: InfoResponse | null;
  displayAppInstaller: boolean;
  isAppInstallable: boolean;
  appInstallerPrompt: BeforeInstallPromptEvent | null;
  isLoading: boolean;
  memberSettings: MemberSettings;
  isWsConnected?: boolean;
}

const initialState: PreferenceSliceState = {
  serverInfo: null,
  displayAppInstaller: false,
  isAppInstallable: false,
  appInstallerPrompt: null,
  isLoading: true,
  memberSettings: getStoredMemberSettings(),
  isWsConnected: false,
};

const preferenceSlice = createSlice({
  name: "@preference",
  initialState,
  reducers: {
    setServerInfo(state, action: PayloadAction<InfoResponse>) {
      state.serverInfo = action.payload;
      if (action.payload) {
        state.isLoading = false;
      }
      // Build & persist member settings from server info
      state.memberSettings = buildMemberSettings(action.payload);
    },
    setDisplayAppInstaller(state, action: PayloadAction<boolean>) {
      state.displayAppInstaller = action.payload;
    },
    setIsLoading(state, action: PayloadAction<boolean>) {
      state.isLoading = action.payload;
    },
    setIsWsConnected(state, action: PayloadAction<boolean>) {
      state.isWsConnected = action.payload;
    },
    setIsAppInstallable(state, action: PayloadAction<boolean>) {
      state.isAppInstallable = action.payload;
    },
    setAppInstallerPrompt(state, action: PayloadAction<BeforeInstallPromptEvent>) {
      state.appInstallerPrompt = action.payload;
    },
  },
});

export const { setServerInfo, setDisplayAppInstaller, setIsLoading, setIsWsConnected } = preferenceSlice.actions;

export default preferenceSlice;
